import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule, MatDialogContent, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule, DatePipe } from '@angular/common';

import { FseService, FactureSearcher, FacturePreteLot, StateHelper } from '@app/fse/fse.service';
import { DateShortFrPipe } from '@app/fse/fse.pipe';

import * as fselib from 'mercalink-fselib'; 

export interface DetailDialogData {
	fSEOrder: fselib.FSEOrder,
	mode: string,
}

@Component({
  selector: 'app-detail-lot',
	standalone: true,
  imports: [CommonModule, MatDialogModule, MatDialogContent, DatePipe, DateShortFrPipe],
  templateUrl: './detail-lot.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./detail-lot.component.scss', '../fses/fses.component.scss'],
})
export class DetailLotComponent {
	readonly dialogdata = inject<DetailDialogData>(MAT_DIALOG_DATA as any);	// 'as any' tricks the compiler
	public batch?:fselib.Batch;
	public rsps?:fselib.RSP[]=[];
	public stateHelper: StateHelper = inject(StateHelper);
	public fseService: FseService = inject(FseService);
	
	constructor() { }
		
	ngOnInit(): void {
		this.batch = (this.dialogdata.mode==='FSE' ? this.dialogdata.fSEOrder.lnk_batch_fse : (this.dialogdata.mode==='DRE' ? this.dialogdata.fSEOrder.lnk_batch_dre : undefined));
		this.rsps = (this.dialogdata.mode==='FSE' ? this.dialogdata.fSEOrder.lnk_rsp_fses : (this.dialogdata.mode==='DRE' ? this.dialogdata.fSEOrder.lnk_rsp_dres : []));		
		//this.rsp = (this.dialogdata.mode==='FSE' ? this.dialogdata.fSEOrder.lnk_rsp_fses : (this.dialogdata.mode==='DRE' ? this.dialogdata.fSEOrder.lnk_rsp_dres : undefined));
		//console.log("[DetailLotComponent ngOnInit] rsp: " + JSON.stringify(this.rsp, null, 2));
	}	
}
